import { createFileRoute } from "@tanstack/react-router";
import OutsourcingModelsComparison from "@/pages/blog/OutsourcingModelsComparison";

export const Route = createFileRoute("/en/blog/outsourcing-models-comparison")({
  component: OutsourcingModelsComparison,
});
